import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import Notification from "../../components/ui/Notification";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [notif, setNotif] = useState({
    type: "info",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setNotif({ message: "" });

    try {
      const res = await signInWithEmailAndPassword(auth, email, password);

      const userRef = doc(db, "users", res.user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        throw new Error("No role found");
      }

      const { role } = userSnap.data();

      if (role !== "admin") {
        throw new Error("Not admin");
      }

      setNotif({
        type: "success",
        message: "Hyrja u krye me sukses",
      });

      setTimeout(() => {
        navigate("/admin");
      }, 600);
    } catch (err) {
      setNotif({
        type: "error",
        message: "Nuk keni qasje si administrator",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#e0d8c3]/20 px-4">
      <div className="w-full max-w-md rounded-2xl border border-[#a6a6a6]/30 bg-white p-6 shadow-lg">
        <h1 className="mb-1 text-center text-2xl font-bold text-[#000000]">
          Hyrje për administratorë
        </h1>

        <p className="mb-6 text-center text-sm text-[#a6a6a6]">
          Ky panel është vetëm për administratorë
        </p>

        <Notification
          type={notif.type}
          message={notif.message}
          onClose={() => setNotif({ message: "" })}
        />

        <form onSubmit={handleSubmit} className="mt-4 space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-[#000000]">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-[#a6a6a6]/50 px-3 py-2 text-[#000000] focus:outline-none focus:ring-2 focus:ring-[#e0d8c3] focus:border-[#e0d8c3] bg-white"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-[#000000]">
              Fjalëkalimi
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-[#a6a6a6]/50 px-3 py-2 text-[#000000] focus:outline-none focus:ring-2 focus:ring-[#e0d8c3] focus:border-[#e0d8c3] bg-white"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-[#000000] py-2 font-medium text-[#ffffff] hover:bg-[#000000]/90 transition disabled:opacity-60"
          >
            {loading ? "Duke u kyçur..." : "Hyr"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
